import style from "./styles/CardVideo.module.css";

import { ICardVideoProps } from "../../interface/interface";

// Order imports
// Styles
// Native and other dependences
// Actions Redux
// Actions Controllers and constants
// Components
// Interfaces

const CardVideo: React.FC<ICardVideoProps> = (props) => {
  // console.log(props, 'las props que llegan a la card')
  return (
    <div
      key={props.videoId}
      className={style.middleCardImage}
      onClick={() => props.selectVideo()}
      style={{
        backgroundImage: `url(${props.image})`,
      }}
    >
      {/* <div className={style.middleCard}> */}

      {/*<div className={style.middleCardTop}> */}
      {/* <p className={style.videoDescription}><strong>{props.title}</strong></p> */}
      {/* <p style={{ display: "none" }}>{props.description}</p>
                    <p style={{ display: "none" }}>Id del canal: {props.channelId}</p> */}
      {/* </div> */}
      {/* 
                <div className={style.middleCardButtons}>
                    <button onClick={() => props.addVideoList()}
                    className={style.middleCardButtons}>Add</button>
                    <button onClick={() => props.getUrlVideo(props.videoId, props.channelTitle)}
                    className={style.middleCardButtons}>Play</button>
                    <button onClick={() => props.getChannel(props.channelId, "channelVideos")}
                    className={style.middleCardButtons}>Channel</button>
                </div> */}

      {/* </div> */}
    </div>
  );
};

export default CardVideo;
